import { publicApi } from "../../http/axios.public";
import { privateApi } from "../../http/axios.instance";
import { logger } from "../../utils/logger";
const MFA_SETUP_URL = '/auth/mfa/setup';
const MFA_ENABLE_URL = '/auth/mfa/enable';
const MFA_DISABLE_URL = '/auth/mfa/disable';
/**
 * SecurityService
 * Mengelola pelaporan kejadian keamanan dan fitur keamanan akun (MFA).
 */
export const SecurityService = {
    /**
     * Melaporkan anomali keamanan.
     */
    reportAnomaly: async (payload) => {
        try {
            await publicApi.post("/auth/security/report", payload);
        }
        catch (err) {
            logger.error("[SECURITY] Gagal melapor anomali keamanan:", err);
        }
    },
    /**
     * Mengambil data rahasia dan QR untuk pendaftaran MFA.
     */
    setupMfa: async () => {
        logger.info("[MFA-SERVICE] Fetching setup data...");
        const response = await privateApi().get(MFA_SETUP_URL);
        logger.info("[MFA-SERVICE] Raw Response:", response.data);
        if (!response.data || !response.data.data) {
            logger.error("[MFA-SERVICE] Data data is missing in response!");
            throw new Error("Data konfigurasi MFA tidak ditemukan dari server.");
        }
        return response.data.data;
    },
    /**
     * Memvalidasi OTP pertama untuk mengaktifkan MFA secara permanen.
     */
    enableMfa: async (payload) => {
        const response = await privateApi().post(MFA_ENABLE_URL, payload);
        return response.data.data;
    },
    /**
     * Menonaktifkan MFA dengan verifikasi password.
     */
    disableMfa: async (password) => {
        const response = await privateApi().post(MFA_DISABLE_URL, { password });
        return response.data.status === 200;
    },
    /**
     * Mengubah password akun.
     */
    changePassword: async (payload) => {
        await privateApi().post('/auth/password/change', payload);
    }
};
